import { useFeatureValue } from '@growthbook/growthbook-react';
import { useSelector } from 'react-redux';
import type { RootState } from '@/redux/store';
import { FISCAL_ADVISOR_FLAG } from '../constants/flag';

const COHORT_START = new Date('2026-06-08T00:00:00Z');

export const useIsFiscalAdvisor = (): boolean | null => {
  const user = useSelector((s: RootState) => s.profile.user);
  const flagValue = useFeatureValue<boolean>(FISCAL_ADVISOR_FLAG, false);

  if (!user) return null;

  const joinedAt = user.joined_at;
  if (!joinedAt) return false;
  if (new Date(joinedAt) < COHORT_START) return false;

  return flagValue;
};
